import React from 'react';
import { Box, Typography, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const ACTION_CONFIG = {
  dispatched:     { color: '#22c55e', label: { pt: 'Despachada',     en: 'Dispatched' } },
  re_dispatched:  { color: '#3b82f6', label: { pt: 'Re-despachada',  en: 'Re-dispatched' } },
  unassigned:     { color: '#ef4444', label: { pt: 'Desatribuída',   en: 'Unassigned' } },
};

const useStyles = makeStyles(() => ({
  root: {
    padding: '8px 12px',
  },
  loading: {
    display: 'flex', justifyContent: 'center', padding: '16px 0',
  },
  empty: {
    textAlign: 'center', padding: '14px 0',
  },
  entry: {
    display: 'flex', gap: 10, position: 'relative',
    minHeight: 48,
  },
  timeline: {
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    width: 16, flexShrink: 0, paddingTop: 2,
  },
  dot: {
    width: 10, height: 10, borderRadius: '50%', flexShrink: 0, zIndex: 1,
  },
  line: {
    width: 2, flex: 1, marginTop: 2,
  },
  content: {
    flex: 1, paddingBottom: 10, minWidth: 0,
  },
  actionLabel: {
    fontSize: '0.7rem', fontWeight: 700, lineHeight: 1.3,
  },
  driverName: {
    fontSize: '0.68rem', fontWeight: 600, color: '#0f172a', lineHeight: 1.3,
  },
  userName: {
    fontSize: '0.6rem', color: '#94a3b8', lineHeight: 1.3,
  },
  dateText: {
    fontSize: '0.6rem', color: '#94a3b8', lineHeight: 1.3,
  },
  notes: {
    fontSize: '0.6rem', color: '#64748b', fontStyle: 'italic',
    marginTop: 2, lineHeight: 1.3,
  },
}));

function DispatchHistoryPanel({ history = [], loading = false, lang = 'pt' }) {
  const classes = useStyles();

  if (loading) {
    return (
      <Box className={classes.loading}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (!history || history.length === 0) {
    return (
      <Box className={classes.empty}>
        <Typography style={{ fontSize: '0.72rem', color: '#94a3b8' }}>
          {lang === 'pt' ? 'Sem histórico de despacho' : 'No dispatch history'}
        </Typography>
      </Box>
    );
  }

  return (
    <Box className={classes.root}>
      {history.map((entry, idx) => {
        const cfg = ACTION_CONFIG[entry.action] || ACTION_CONFIG.dispatched;
        const isLast = idx === history.length - 1;
        const dateStr = entry.createdAt
          ? moment(entry.createdAt).format('DD MMM YYYY, HH:mm')
          : '';

        return (
          <Box key={entry.id || idx} className={classes.entry}>
            <Box className={classes.timeline}>
              <Box className={classes.dot} style={{ background: cfg.color }} />
              {!isLast && (
                <Box className={classes.line} style={{ background: `${cfg.color}40` }} />
              )}
            </Box>
            <Box className={classes.content}>
              <Typography className={classes.actionLabel} style={{ color: cfg.color }}>
                {cfg.label[lang] || cfg.label.pt}
              </Typography>
              {entry.driver?.name && (
                <Typography className={classes.driverName}>
                  {entry.driver.name}
                </Typography>
              )}
              {entry.user?.name && (
                <Typography className={classes.userName}>
                  {lang === 'pt' ? 'por' : 'by'} {entry.user.name}
                </Typography>
              )}
              {dateStr && (
                <Typography className={classes.dateText}>{dateStr}</Typography>
              )}
              {entry.notes && (
                <Typography className={classes.notes}>{entry.notes}</Typography>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

export default DispatchHistoryPanel;
